export function getAge(DOB, identifyProgramme)
{
    if (!DOB) {
        return null;
    }
    let today = new Date();
    let dateParts = DOB.split("/");

    let dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

    let age = today.getFullYear() - dateObject.getFullYear();

    let m = today.getMonth() - dateObject.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < dateObject.getDate())) {
        age = age - 1;
    }

    if (
        dateParts[0] === "" ||
        dateParts[0].length !== 2 ||
        dateParts[1] === "" ||
        dateParts[1].length !== 2 ||
        dateParts[2] === "" ||
        dateParts[2].length !== 4
    ) {
        return "incomplete";
    }

    if (identifyProgramme === 'enterprise') {
        if (age < 18 || age > 30) {
            return false;
        }
    } else {
        if (age < 16 || age > 30) {
            return false;
        }
    }
}
